module.exports = "/images/ico-przelew-tradycyjny.svg?76599100c3660e3651dc6445900cf0f4";